import { create } from 'zustand';
import { getCompanyEventsApi } from '../../../api/api';

export const useEventsStore = create((set) => ({
  data: [],
  isLoading: false,
  error: null,
  total: 0,

  fetchCompanyEvents: async (page, limit, searchValue) => {
    set({ isLoading: true, error: null });

    await getCompanyEventsApi(
      page,
      limit,
      searchValue,
      (data) => {
        set({ data: data?.events || [], total: data?.total ?? 0, isLoading: false });
      },
      (err) => {
        set({ error: err.error || 'Ошибка при загрузке данных', isLoading: false });
      }
    );
  },
}));
